module.exports = __webpack_public_path__ + "img/title.3421167f.png";